<template>
  <v-data-table :headers="userListHeaders" :items="users">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Utilisateurs du groupe</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small v-on="on" class="themed">Nouvel utilisateur</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Nouvel utilisateur</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-alert type="error" v-if="error">{{error}}</v-alert>
                <user-form v-model="userModel" />
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color text @click="close" class="themed">Cancel</v-btn>
              <v-btn color="primary" small @click="createUser" class="themed">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.role="{item}">
      <v-chip :color="getRole(item.role).color" dark small>{{getRole(item.role).text}}</v-chip>
    </template>
    <template v-slot:item.funds="{item}">
      <limit-funds :user="item" @update="$emit('reload')" />
    </template>

    <template v-slot:item.action="{item}">
      <v-dialog
        v-model="editDialog[item.id]"
        max-width="500px"
        v-if="item.role!='owner' && item.id != currentUser.id"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon fab small v-on="on" @click="editUser = item">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Modifier l'utilisateur</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-alert type="error" v-if="error">{{error}}</v-alert>
              <user-form v-model="editUser" />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color text @click="close" class="themed">Cancel</v-btn>
            <v-btn color="primary" small @click="updateUser" class="themed">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deleteDialog[item.id]"
        max-width="450px"
        v-if="item.role!='owner' && item.id != currentUser.id"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon fab small v-on="on">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Effacer l'utilisateur</v-card-title>
          <v-card-text>
            <v-alert type="error" v-if="userErrors[item.id]">{{userErrors[item.id]}}</v-alert>
            <v-row>
              <v-col
                cols="12"
              >Vous êtes sur le point d'effacer un utilisateur, les commandes de cet utilisateur seront transférer à son manager direct</v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="$set(deleteDialog, item.id, false)">Annuler</v-btn>
            <v-spacer />
            <v-btn class="primary themed" @click="sendDelete(item)">Confirmer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-data-table>
</template>


<script>
import UserForm from "./UserForm";
import LimitFunds from "./LimitFunds";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    UserForm,
    LimitFunds
  },
  name: "UserList",
  data: () => ({
    users: [],
    dialog: false,
    deleteDialog: {},
    editDialog: {},
    editUser: {},
    fundsDialog: null,
    error: null,
    mandatoryRules: v => !!v || "Ce champ est obligatoire",
    userModel: {},
    userListHeaders: [
      { text: "Nom", value: "lastname" },
      { text: "Prénom", value: "firstname" },
      { text: "Email", value: "email" },
      { text: "Téléphone", value: "phone" },
      { text: "Role", value: "role" },
      { text: "Pouvoir d'achat", value: "funds" },
      { text: "Actions", value: "action" }
    ],
    userErrors: {}
  }),
  props: {
    groupId: {
      type: Number,
      required: true
    },
    userList: {
      type: Array
    }
  },
  computed: {
    ...mapGetters("auth", ["currentUser"])
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("users", ["create", "delete", "update"]),
    getRole(role) {
      if (role == "owner") {
        return { color: "red", text: "Propriétaire" };
      } else if (role == "manager") {
        return { color: "green", text: "Manager" };
      }
      return { color: "grey", text: "Collaborateur" };
    },
    initialize() {
      this.userModel.group_id = this.groupId;
      this.users = this.userList;
    },
    close() {
      this.dialog = false;
      this.editDialog[this.editUser.id] = false;
      this.editUser = {};
      this.userModel = {};
      this.userModel.group_id = this.groupId;
    },
    createUser() {
      this.create(this.userModel)
        .then(user => {
          this.users.push(user);
          this.close();
        })
        .catch(error => {
          this.error = error.errors;
        });
    },
    updateUser() {
      this.update(this.editUser)
        .then(() => {
          this.close();
        })
        .catch(error => {
          this.error = error.errors;
        });
    },
    sendDelete(item) {
      this.delete(item)
        .then(() => {
          this.users = this.users.filter(user => user.id != item.id);
        })
        .catch(error => {
          this.userListHeaders[item.id] = error.error;
        });
    }
  }
};
</script>

<style>
</style>